import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Card, Stack, TextField, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Iconify from '../components/iconify';
import * as authService from '../services/authService';
import { errorNotification, infoNotification } from '../services/notificationService';

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      errorNotification('Passwords do not match');
      return;
    }
    if (newPassword.length < 6) {
      errorNotification('Password must be at least 6 characters');
      return;
    }
    setIsLoading(true);
    try {
      await authService.changePassword(currentPassword, newPassword);
      infoNotification('Password changed successfully');
      navigate('/dashboard/app', { replace: true });
    } catch (error) {
      errorNotification(error.response?.data?.message || 'Failed to change password');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title> VPSI | Change Password </title>
      </Helmet>
      <Container maxWidth="sm">
        <Typography variant="h4" gutterBottom sx={{ mt: 4 }}>
          Change Your Password
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
          Your administrator has set a temporary password. Please change it before continuing.
        </Typography>
        <Card sx={{ p: 3 }}>
          <form onSubmit={handleSubmit}>
            <Stack spacing={3}>
              <TextField
                label="Current Password"
                type={showCurrent ? 'text' : 'password'}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowCurrent(!showCurrent)} edge="end">
                        <Iconify icon={showCurrent ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="New Password"
                type={showNew ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowNew(!showNew)} edge="end">
                        <Iconify icon={showNew ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Confirm New Password"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isLoading}>
                Change Password
              </LoadingButton>
            </Stack>
          </form>
        </Card>
      </Container>
    </>
  );
}
